import { Link } from 'react-router-dom';

import { Path } from '@/enums';

const Unauthorized = () => {
  return (
    <div>
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
      <Link to={Path.Login}>Return to Login</Link>
    </div>
  );
};

export default Unauthorized;
